import { render, staticRenderFns } from "./ResetUserFromCohort.vue?vue&type=template&id=a87ceee8&scoped=true&"
import script from "./ResetUserFromCohort.vue?vue&type=script&lang=js&"
export * from "./ResetUserFromCohort.vue?vue&type=script&lang=js&"
import style0 from "./ResetUserFromCohort.vue?vue&type=style&index=0&id=a87ceee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87ceee8",
  null
  
)

export default component.exports